import { useCallback } from 'react';

import { getCreatedResourceMessage } from 'src/data/performance';
import { useErrorHandler } from 'src/services/useErrorHandler';
import { useCustomerActions } from 'src/store/customer';
import { useNotificationActions } from 'src/store/notification';
import { useResourceActions } from 'src/store/resource';

export const useExtractResource = () => {
  const customerActions = useCustomerActions();
  const resourceActions = useResourceActions();
  const notificationActions = useNotificationActions();
  const handleError = useErrorHandler();

  return useCallback(
    async ({ name, url, tags, file, contentType }) => {
      const createdResource = await resourceActions.extractResource({
        name,
        url,
        tags,
        file,
        contentType,
      });
      if (createdResource) {
        const message = getCreatedResourceMessage(createdResource);
        notificationActions.displaySuccess(message, null, { timeout: 5000 });
      }

      customerActions.refreshCurrentCustomerFeatureLimit();
      resourceActions.queryWorkspaceResources().catch(handleError);

      return createdResource;
    },
    [resourceActions, customerActions, handleError, notificationActions]
  );
};
